const baseGraphOptions = {
  plotOptions: {
    bar: {
      distributed: true,
    },
  },
  legend: {
    show: false,
  },
  states: {
    hover: {
      filter: {
        type: 'none',
        value: 0,
      },
    },
    active: {
      filter: {
        type: 'none',
        value: 0,
      },
    },
  },
  dataLabels: {
    enabled: false,
  },
  grid: {
    show: false,
  },
  axis: {
    show: false,
  },
  axisBorder: {
    show: false,
  },
  labels: {
    show: false,
  },
  yaxis: {
    labels: {
      show: false,
    },
  },
  tooltip: {
    enabled: false,
  },
  xaxis: {
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    labels: {
      show: false,
    },
    categories: [],
  },
};


const lineGraphOptions = {
  ...baseGraphOptions,
  stroke: {
    width: 2,
  },
  colors: ['#0D87A0', '#5AC0BE', '#9FE3CB', '#4F5A9E', '#916899'],  
  xaxis: {
    labels: {
      show: false,
    },
    crosshairs: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
};

const staticData = [
  {
    data: [28, 29, 33, 36, 32, 32, 33],
  },
  {
    data: [12, 11, 14, 89, 17, 13, 13],
  },
];

export {
  baseGraphOptions,
  staticData,
  lineGraphOptions,
};
